module.exports = __webpack_public_path__ + "static/img/green_01_2025.2676b8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/green_01_2025.jpg
// module id = XYQP
// module chunks = 100